var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Steps", { attrs: { "current-page": 3 } }),
      _c(
        "div",
        { staticClass: "container container-xs" },
        [
          _c("div", { staticClass: "text-center heading-wrapper" }, [
            _c("span", { staticClass: "heading" }, [
              _vm._v(_vm._s(_vm.$t("my_shopping_cart"))),
            ]),
          ]),
          _vm.cartCount()
            ? [
                _c("div", { staticClass: "purchase-wrapper" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c("span", { staticClass: "main-text" }, [
                      _vm._v(_vm._s(_vm.$t("order_step3"))),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "alert alert-danger text-center" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("please_check_informations")) + " "
                  ),
                ]),
                _c("CartProducts", { attrs: { products: _vm.getCart() } }),
              ]
            : [
                _c("div", [
                  _c("p", { staticClass: "main-text text-center mb-65" }, [
                    _vm._v(" " + _vm._s(_vm.$t("cart_empty")) + " "),
                  ]),
                  _c("p", { staticClass: "p-text text-center mb-5" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("buy_vignette_or_bridge_fee")) + " "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "d-md-flex justify-content-md-around" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-purple w-100 mb-4 mb-md-0",
                        attrs: {
                          to: { name: "vignette" },
                          dusk: "order-vignette",
                          type: "button",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("i_want")) +
                            " " +
                            _vm._s(_vm.$tc("vignetteWord", 1)) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-purple w-100",
                        attrs: {
                          to: { name: "toll" },
                          dusk: "order-vignette",
                          type: "button",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("i_want")) +
                            " " +
                            _vm._s(_vm.$tc("tollWord", 0)) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
          _vm.getCartWithErrors().length
            ? [
                _c("br"),
                _c("strong", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.$t("cart_validation_errors"))),
                ]),
                _c("CartProducts", {
                  attrs: {
                    products: _vm.getCartWithErrors(),
                    showDeleteBtn: false,
                  },
                }),
              ]
            : _vm._e(),
          _c("CartButtons"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }